// Traductions ca/it/pt/nl générées automatiquement pour les exercices TDAH enfants
const extra = {
  "ca": {
    "superpowers_title": "Els Meus Superpoders Còsmics",
    "superpowers_subtitle": "Descobreix les teves forces secretes d'astronauta!",
    "safety_bubble_title": "La Meva Bombolla Espacial",
    "safety_bubble_subtitle": "Crea el teu escut de protecció personalitzat",
    "relaxation_title": "Retorn a l'Òrbita",
    "relaxation_subtitle": "Relaxació muscular per buidar el teu motor",
    "agitation_radar_title": "El Meu Radar Galàctic",
    "agitation_radar_subtitle": "Detecta i comprèn les teves sensacions",
    "recharge_title": "Estació de Recàrrega",
    "recharge_subtitle": "Troba les teves activitats per recarregar les teves bateries",
    "turbo_brain_title": "La Meva Nau Turbo",
    "turbo_brain_subtitle": "Comprèn el teu cervell turbo i el seu fre",
    "mission_title": "Missió Espacial",
    "mission_subtitle": "Afronta reptes d'autocontrol!",
    "superhero_day_title": "El Meu Dia d'Astronauta",
    "superhero_day_subtitle": "Segueix la teva energia al llarg del dia",
    "victories_title": "Les Meves Estrelles de Victòria",
    "victories_subtitle": "Celebra els teus èxits, fins i tot els més petits!",
    "therapist_questions_title": "Missatge al Centre de Control",
    "therapist_questions_subtitle": "Anoteu les vostres preguntes per al vostre terapeuta",
    "save": "Desar",
    "add": "Afegir",
    "other": "Alguna cosa més...",
    "history": "Historial",
    "no_history": "Cap historial",
    "exercise_not_found": "Exercici no trobat",
    "saved_success": "Bravo, exercici desat!",
    "save_error": "Error en desar",
    "notes": "Notes",
    "notes_placeholder": "Observacions del dia...",
    "sp_known": "Els meus superpoders que ja conec",
    "sp_custom": "Quins són els meus altres superpoders?",
    "sp_placeholder": "Superpoder",
    "sp_save": "Desar els meus superpoders",
    "sp_preset_1": "M'adono de detalls que els altres no veuen",
    "sp_preset_2": "Tinc moltes idees per jugar",
    "sp_preset_3": "Entenc els altres quan no es troben bé",
    "sp_preset_4": "Estic molt concentrat quan m'apassiona",
    "bubble_color": "Quin color té la meva bombolla?",
    "bubble_color_hint": "Ex: blau tranquil, verd relaxant, rosa suau...",
    "bubble_color_ph": "Color de la meva bombolla...",
    "bubble_shape": "Quina forma té?",
    "bubble_shape_hint": "Rodona, quadrada, com un escut...",
    "bubble_shape_ph": "Forma...",
    "bubble_texture": "Quina és la seva textura?",
    "bubble_texture_hint": "Suau, sòlida, brillant...",
    "bubble_texture_ph": "Textura...",
    "bubble_activities": "Què puc fer a la meva bombolla?",
    "bubble_activities_hint": "Llegir, jugar tranquil·lament, dibuixar, somiar...",
    "bubble_activities_ph": "Les meves activitats a la bombolla...",
    "bubble_noise": "Nivell de soroll a la meva bombolla",
    "bubble_noise_silence": "silenci",
    "bubble_noise_low": "una mica",
    "bubble_noise_medium": "mitjà",
    "bubble_signal": "Com saben els adults quan demano una pausa-bombolla?",
    "bubble_signal_hint": "Paraula clau, targeta, gest...",
    "bubble_signal_ph": "El meu senyal...",
    "bubble_save": "Desar la meva bombolla",
    "relax_steps_title": "Passos de la relaxació",
    "relax_after": "Després de l'exercici, em sento...",
    "relax_after_ph": "Més tranquil, menys acalorat, relaxat...",
    "relax_hands": "Mans",
    "relax_arms": "Braços",
    "relax_legs": "Cames",
    "relax_belly": "Ventre",
    "relax_face": "Cara",
    "relax_s1": "Tanco els punys molt fort, com si volgués esclafar una taronja. Compto fins a 5.",
    "relax_s2": "Afluixo suaument les mans. Sento la relaxació.",
    "relax_s3": "Estiro els braços molt fort, com si volgués tocar el sostre. Compto fins a 5.",
    "relax_s4": "Afluixo suaument els braços. Sento la relaxació.",
    "relax_s5": "Tanco les cames molt fort. Compto fins a 5.",
    "relax_s6": "Afluixo les cames. Sento la relaxació.",
    "relax_s7": "Tanco el ventre molt fort. Compto fins a 5.",
    "relax_s8": "Afluixo el ventre. Sento la relaxació.",
    "relax_s9": "Faig una ganyota molt forta (cara tensa). Compto fins a 5.",
    "relax_s10": "Afluixo la cara. Sento la relaxació.",
    "radar_location": "On era / Què feia",
    "radar_location_ph": "A casa, a classe...",
    "radar_sensations": "Què vaig sentir al meu cos",
    "radar_sensations_ph": "Motor que vibra, cames que es mouen, ganes de parlar, cap calent...",
    "radar_intensity": "Intensitat (1 = una mica, 10 = molt fort)",
    "radar_boredom": "Nivell d'avorriment",
    "radar_urge": "Ganes de provocar / fer malifetes",
    "radar_action": "Què he fet",
    "radar_action_ph": "He utilitzat la meva bombolla, he fet la meva relaxació...",
    "radar_after": "Com m'he sentit després?",
    "radar_after_ph": "Millor, igual, menys agitat...",
    "recharge_what": "Què he fet?",
    "recharge_what_hint": "Llegir, Lego, dibuixar, abraçades, no fer res...",
    "recharge_what_ph": "La meva activitat calmant...",
    "recharge_during": "Com m'he sentit durant?",
    "recharge_during_ph": "Tranquil, relaxat, content...",
    "recharge_after": "Com m'he sentit després?",
    "recharge_after_ph": "Recarregat, a punt per jugar, menys cansat...",
    "turbo_helps": "El meu turbo m'ajuda a...",
    "turbo_brake": "Quan el meu fre està cansat...",
    "turbo_preset_1": "Inventar jocs",
    "turbo_preset_2": "Respondre ràpid",
    "turbo_preset_3": "Adonar-me de moltes coses",
    "turbo_brake_1": "Interrompo els altres",
    "turbo_brake_2": "Faig malifetes sense pensar",
    "turbo_brake_3": "M'enfado de cop",
    "mission_scenario": "La situació",
    "mission_scenario_hint": "Ex: La mare es prepara, sóc a classe, som al restaurant...",
    "mission_scenario_ph": "Descriu la situació...",
    "mission_usual": "El que faig normalment",
    "mission_usual_ph": "Parlo, toco tot, em moc...",
    "mission_turbo": "El que em diu el meu cervell turbo",
    "mission_turbo_ph": "M'avorreixo, vull parlar de seguida, i si faig moltes preguntes...",
    "mission_outcome": "El que passa després (normalment)",
    "mission_outcome_ph": "La mare s'enfada, tothom està estressat...",
    "mission_activity": "La meva missió: activitat tranquil·la escollida",
    "mission_activity_ph": "Dibuix, còmic, Lego, trencaclosques...",
    "mission_result": "Resultat de la missió",
    "mission_result_ph": "Com ha anat? Ho he aconseguit? Ha estat difícil?",
    "mission_done": "Missió complerta!",
    "day_energy": "La meva energia al llarg del dia",
    "day_morning": "Matí a casa",
    "day_commute": "Trajecte",
    "day_class_am": "Classe matí",
    "day_lunch": "Dinar",
    "day_afternoon": "Tarda",
    "day_sport": "Esport / Activitat",
    "day_evening": "Vespre",
    "day_bedtime": "Hora d'anar a dormir",
    "day_full": "Ple",
    "day_medium": "Mitjà",
    "day_empty": "Buit",
    "day_need_move": "moure's",
    "day_need_talk": "parlar",
    "day_need_calm": "estar tranquil",
    "day_need_hug": "abraçades",
    "day_save": "Desar el meu dia",
    "victory_title": "La meva victòria",
    "victory_examples": "Exemples: He dormit sense despertar-me / He agafat el metro sense estrès / M'he menjat tot el menjar / He aconseguit calmar-me sol",
    "victory_ph": "Avui, he aconseguit...",
    "victory_proud": "Estic orgullós de mi perquè...",
    "victory_proud_ph": "Perquè era difícil i ho he aconseguit...",
    "victory_save": "Afegeix la meva estrella!",
    "questions_title": "Les meves preguntes",
    "questions_ph": "Pregunta",
    "questions_add": "Afegeix una pregunta",
    "questions_save": "Envia les meves preguntes",
    "hist_intensity": "Intensitat",
    "hist_periods": "períodes registrats"
  },
  "it": {
    "superpowers_title": "I Miei Superpoteri Cosmici",
    "superpowers_subtitle": "Scopri le tue forze segrete da astronauta!",
    "safety_bubble_title": "La Mia Bolla Spaziale",
    "safety_bubble_subtitle": "Crea il tuo scudo di protezione personalizzato",
    "relaxation_title": "Ritorno in Orbita",
    "relaxation_subtitle": "Rilassamento muscolare per svuotare il tuo motore",
    "agitation_radar_title": "Il Mio Radar Galattico",
    "agitation_radar_subtitle": "Rileva e comprendi le tue sensazioni",
    "recharge_title": "Stazione di Ricarica",
    "recharge_subtitle": "Trova le tue attività per ricaricare le batterie",
    "turbo_brain_title": "La Mia Nave Turbo",
    "turbo_brain_subtitle": "Comprendi il tuo cervello turbo e il suo freno",
    "mission_title": "Missione Spaziale",
    "mission_subtitle": "Affronta sfide di autocontrollo!",
    "superhero_day_title": "La Mia Giornata da Astronauta",
    "superhero_day_subtitle": "Segui la tua energia durante la giornata",
    "victories_title": "Le Mie Stelle della Vittoria",
    "victories_subtitle": "Celebra i tuoi successi, anche i più piccoli!",
    "therapist_questions_title": "Messaggio al Centro di Controllo",
    "therapist_questions_subtitle": "Annota le tue domande per il tuo terapeuta",
    "save": "Salva",
    "add": "Aggiungi",
    "other": "Altro...",
    "history": "Cronologia",
    "no_history": "Nessuna cronologia",
    "exercise_not_found": "Esercizio non trovato",
    "saved_success": "Bravo, esercizio salvato!",
    "save_error": "Errore durante il salvataggio",
    "notes": "Note",
    "notes_placeholder": "Osservazioni della giornata...",
    "sp_known": "I miei superpoteri che già conosco",
    "sp_custom": "Quali sono gli altri miei superpoteri?",
    "sp_placeholder": "Superpotere",
    "sp_save": "Salva i miei superpoteri",
    "sp_preset_1": "Noto dettagli che gli altri non vedono",
    "sp_preset_2": "Ho tante idee per giocare",
    "sp_preset_3": "Capisco gli altri quando non stanno bene",
    "sp_preset_4": "Sono molto concentrato quando qualcosa mi appassiona",
    "bubble_color": "Che colore ha la mia bolla?",
    "bubble_color_hint": "Es: blu calmo, verde rilassante, rosa tenue...",
    "bubble_color_ph": "Colore della mia bolla...",
    "bubble_shape": "Che forma ha?",
    "bubble_shape_hint": "Rotonda, quadrata, come uno scudo...",
    "bubble_shape_ph": "Forma...",
    "bubble_texture": "Qual è la sua consistenza?",
    "bubble_texture_hint": "Morbida, solida, brillante...",
    "bubble_texture_ph": "Consistenza...",
    "bubble_activities": "Cosa mi è permesso fare nella mia bolla?",
    "bubble_activities_hint": "Leggere, giocare tranquillamente, disegnare, sognare...",
    "bubble_activities_ph": "Le mie attività nella bolla...",
    "bubble_noise": "Livello di rumore nella mia bolla",
    "bubble_noise_silence": "silenzio",
    "bubble_noise_low": "un po'",
    "bubble_noise_medium": "medio",
    "bubble_signal": "Come fanno gli adulti a sapere quando chiedo una pausa-bolla?",
    "bubble_signal_hint": "Parola in codice, carta, gesto...",
    "bubble_signal_ph": "Il mio segnale...",
    "bubble_save": "Salva la mia bolla",
    "relax_steps_title": "Fasi del rilassamento",
    "relax_after": "Dopo l'esercizio, mi sento...",
    "relax_after_ph": "Più calmo, meno accaldato, rilassato...",
    "relax_hands": "Mani",
    "relax_arms": "Braccia",
    "relax_legs": "Gambe",
    "relax_belly": "Pancia",
    "relax_face": "Viso",
    "relax_s1": "Stringo i pugni molto forte, come se volessi schiacciare un'arancia. Conto fino a 5.",
    "relax_s2": "Rilascio dolcemente le mani. Sento il rilassamento.",
    "relax_s3": "Tendo le braccia molto forte, come se volessi toccare il soffitto. Conto fino a 5.",
    "relax_s4": "Rilascio dolcemente le braccia. Sento il rilassamento.",
    "relax_s5": "Stringo le gambe molto forte. Conto fino a 5.",
    "relax_s6": "Rilascio le gambe. Sento il rilassamento.",
    "relax_s7": "Stringo la pancia molto forte. Conto fino a 5.",
    "relax_s8": "Rilascio la pancia. Sento il rilassamento.",
    "relax_s9": "Faccio una smorfia molto forte (viso contratto). Conto fino a 5.",
    "relax_s10": "Rilascio il viso. Sento il rilassamento.",
    "radar_location": "Dove ero / Cosa stavo facendo",
    "radar_location_ph": "A casa, in classe...",
    "radar_sensations": "Cosa ho sentito nel mio corpo",
    "radar_sensations_ph": "Motore che vibra, gambe che si muovono, voglia di parlare, testa calda...",
    "radar_intensity": "Intensità (1 = un po', 10 = molto forte)",
    "radar_boredom": "Livello di noia",
    "radar_urge": "Voglia di provocare / fare marachelle",
    "radar_action": "Cosa ho fatto",
    "radar_action_ph": "Ho usato la mia bolla, ho fatto il mio rilassamento...",
    "radar_after": "Come mi sono sentito dopo?",
    "radar_after_ph": "Meglio, uguale, meno agitato...",
    "recharge_what": "Cosa ho fatto?",
    "recharge_what_hint": "Leggere, Lego, disegnare, coccole, non fare niente...",
    "recharge_what_ph": "La mia attività calmante...",
    "recharge_during": "Come mi sono sentito durante?",
    "recharge_during_ph": "Calmo, rilassato, contento...",
    "recharge_after": "Come mi sono sentito dopo?",
    "recharge_after_ph": "Ricaricato, pronto a giocare, meno stanco...",
    "turbo_helps": "Il mio turbo mi aiuta a...",
    "turbo_brake": "Quando il mio freno è stanco...",
    "turbo_preset_1": "Inventare giochi",
    "turbo_preset_2": "Rispondere velocemente",
    "turbo_preset_3": "Notare tante cose",
    "turbo_brake_1": "Interrompo gli altri",
    "turbo_brake_2": "Faccio marachelle senza pensare",
    "turbo_brake_3": "Mi arrabbio all'improvviso",
    "mission_scenario": "La situazione",
    "mission_scenario_hint": "Es: La mamma si prepara, sono in classe, siamo al ristorante...",
    "mission_scenario_ph": "Descrivi la situazione...",
    "mission_usual": "Cosa faccio di solito",
    "mission_usual_ph": "Parlo, tocco tutto, mi muovo...",
    "mission_turbo": "Cosa mi dice il mio cervello turbo",
    "mission_turbo_ph": "Mi annoio, voglio parlare subito, e se facessi tante domande...",
    "mission_outcome": "Cosa succede dopo (di solito)",
    "mission_outcome_ph": "La mamma è nervosa, tutti sono stressati...",
    "mission_activity": "La mia missione: attività calma scelta",
    "mission_activity_ph": "Disegno, fumetti, Lego, puzzle...",
    "mission_result": "Risultato della missione",
    "mission_result_ph": "Come è andata? Ci sono riuscito? È stato difficile?",
    "mission_done": "Missione compiuta!",
    "day_energy": "La mia energia durante la giornata",
    "day_morning": "Mattina a casa",
    "day_commute": "Tragitto",
    "day_class_am": "Classe mattina",
    "day_lunch": "Pranzo",
    "day_afternoon": "Pomeriggio",
    "day_sport": "Sport / Attività",
    "day_evening": "Sera",
    "day_bedtime": "Ora di andare a letto",
    "day_full": "Pieno",
    "day_medium": "Medio",
    "day_empty": "Vuoto",
    "day_need_move": "muoversi",
    "day_need_talk": "parlare",
    "day_need_calm": "essere calmo",
    "day_need_hug": "coccole",
    "day_save": "Salva la mia giornata",
    "victory_title": "La mia vittoria",
    "victory_examples": "Esempi: Ho dormito senza svegliarmi / Ho preso la metro senza stress / Ho mangiato tutto il mio pasto / Sono riuscito a calmarmi da solo",
    "victory_ph": "Oggi sono riuscito a...",
    "victory_proud": "Sono fiero di me perché...",
    "victory_proud_ph": "Perché è stato difficile e ci sono riuscito...",
    "victory_save": "Aggiungi la mia stella!",
    "questions_title": "Le mie domande",
    "questions_ph": "Domanda",
    "questions_add": "Aggiungi una domanda",
    "questions_save": "Invia le mie domande",
    "hist_intensity": "Intensità",
    "hist_periods": "periodi tracciati"
  },
  "pt": {
    "superpowers_title": "Os Meus Superpoderes Cósmicos",
    "superpowers_subtitle": "Descobre os teus pontos fortes secretos de astronauta!",
    "safety_bubble_title": "A Minha Bolha Espacial",
    "safety_bubble_subtitle": "Cria o teu escudo de proteção personalizado",
    "relaxation_title": "Regresso à Órbita",
    "relaxation_subtitle": "Relaxamento muscular para esvaziar o teu motor",
    "agitation_radar_title": "O Meu Radar Galáctico",
    "agitation_radar_subtitle": "Deteta e compreende as tuas sensações",
    "recharge_title": "Estação de Recarga",
    "recharge_subtitle": "Encontra as tuas atividades para recarregar as tuas baterias",
    "turbo_brain_title": "A Minha Nave Turbo",
    "turbo_brain_subtitle": "Compreende o teu cérebro turbo e o seu travão",
    "mission_title": "Missão Espacial",
    "mission_subtitle": "Aceita desafios de autocontrolo!",
    "superhero_day_title": "O Meu Dia de Astronauta",
    "superhero_day_subtitle": "Acompanha a tua energia ao longo do dia",
    "victories_title": "As Minhas Estrelas da Vitória",
    "victories_subtitle": "Celebra as tuas conquistas, mesmo as mais pequenas!",
    "therapist_questions_title": "Mensagem para o Centro de Controlo",
    "therapist_questions_subtitle": "Anota as tuas perguntas para o teu terapeuta",
    "save": "Guardar",
    "add": "Adicionar",
    "other": "Outra coisa...",
    "history": "Histórico",
    "no_history": "Nenhum histórico",
    "exercise_not_found": "Exercício não encontrado",
    "saved_success": "Muito bem, exercício guardado!",
    "save_error": "Erro ao guardar",
    "notes": "Notas",
    "notes_placeholder": "Observações do dia...",
    "sp_known": "Os meus superpoderes que já conheço",
    "sp_custom": "Quais são os meus outros superpoderes?",
    "sp_placeholder": "Superpoder",
    "sp_save": "Guardar os meus superpoderes",
    "sp_preset_1": "Reparo em detalhes que os outros não veem",
    "sp_preset_2": "Tenho muitas ideias para brincar",
    "sp_preset_3": "Compreendo os outros quando não estão bem",
    "sp_preset_4": "Fico muito concentrado quando me apaixono por algo",
    "bubble_color": "Que cor tem a minha bolha?",
    "bubble_color_hint": "Ex: azul calmo, verde relaxante, rosa suave...",
    "bubble_color_ph": "Cor da minha bolha...",
    "bubble_shape": "Que forma tem?",
    "bubble_shape_hint": "Redonda, quadrada, como um escudo...",
    "bubble_shape_ph": "Forma...",
    "bubble_texture": "Qual é a sua textura?",
    "bubble_texture_hint": "Suave, sólida, brilhante...",
    "bubble_texture_ph": "Textura...",
    "bubble_activities": "O que me é permitido fazer na minha bolha?",
    "bubble_activities_hint": "Ler, brincar calmamente, desenhar, sonhar...",
    "bubble_activities_ph": "As minhas atividades na bolha...",
    "bubble_noise": "Nível de ruído na minha bolha",
    "bubble_noise_silence": "silêncio",
    "bubble_noise_low": "um pouco",
    "bubble_noise_medium": "médio",
    "bubble_signal": "Como é que os adultos sabem quando peço uma pausa-bolha?",
    "bubble_signal_hint": "Palavra-código, cartão, gesto...",
    "bubble_signal_ph": "O meu sinal...",
    "bubble_save": "Guardar a minha bolha",
    "relax_steps_title": "Etapas do relaxamento",
    "relax_after": "Depois do exercício, sinto-me...",
    "relax_after_ph": "Mais calmo, menos quente, relaxado...",
    "relax_hands": "Mãos",
    "relax_arms": "Braços",
    "relax_legs": "Pernas",
    "relax_belly": "Barriga",
    "relax_face": "Rosto",
    "relax_s1": "Aperto os meus punhos com muita força, como se quisesse esmagar uma laranja. Conto até 5.",
    "relax_s2": "Solto as minhas mãos suavemente. Sinto o relaxamento.",
    "relax_s3": "Estico os meus braços com muita força, como se quisesse tocar o teto. Conto até 5.",
    "relax_s4": "Solto os meus braços suavemente. Sinto o relaxamento.",
    "relax_s5": "Aperto as minhas pernas com muita força. Conto até 5.",
    "relax_s6": "Solto as minhas pernas. Sinto o relaxamento.",
    "relax_s7": "Aperto a minha barriga com muita força. Conto até 5.",
    "relax_s8": "Solto a minha barriga. Sinto o relaxamento.",
    "relax_s9": "Faço uma careta com muita força (rosto tenso). Conto até 5.",
    "relax_s10": "Solto o meu rosto. Sinto o relaxamento.",
    "radar_location": "Onde estava / O que estava a fazer",
    "radar_location_ph": "Em casa, na aula...",
    "radar_sensations": "O que senti no meu corpo",
    "radar_sensations_ph": "Motor a vibrar, pernas a mexer, vontade de falar, cabeça quente...",
    "radar_intensity": "Intensidade (1 = um pouco, 10 = muito forte)",
    "radar_boredom": "Nível de aborrecimento",
    "radar_urge": "Vontade de provocar / fazer asneiras",
    "radar_action": "O que eu fiz",
    "radar_action_ph": "Usei a minha bolha, fiz o meu relaxamento...",
    "radar_after": "Como me senti depois?",
    "radar_after_ph": "Melhor, igual, menos agitado...",
    "recharge_what": "O que fiz?",
    "recharge_what_hint": "Ler, Lego, desenhar, mimos, não fazer nada...",
    "recharge_what_ph": "A minha atividade calmante...",
    "recharge_during": "Como me senti durante?",
    "recharge_during_ph": "Calmo, relaxado, contente...",
    "recharge_after": "Como me senti depois?",
    "recharge_after_ph": "Recarregado, pronto para brincar, menos cansado...",
    "turbo_helps": "O meu turbo ajuda-me a...",
    "turbo_brake": "Quando o meu travão está cansado...",
    "turbo_preset_1": "Inventar jogos",
    "turbo_preset_2": "Responder rápido",
    "turbo_preset_3": "Reparar em muitas coisas",
    "turbo_brake_1": "Interrompo os outros",
    "turbo_brake_2": "Faço asneiras sem pensar",
    "turbo_brake_3": "Fico zangado de repente",
    "mission_scenario": "A situação",
    "mission_scenario_hint": "Ex: A mãe está a preparar-se, estou na aula, estamos no restaurante...",
    "mission_scenario_ph": "Descreve a situação...",
    "mission_usual": "O que costumo fazer",
    "mission_usual_ph": "Falo, toco em tudo, mexo-me...",
    "mission_turbo": "O que o meu cérebro turbo me diz",
    "mission_turbo_ph": "Estou aborrecido, quero falar já, e se eu fizesse muitas perguntas...",
    "mission_outcome": "O que acontece depois (normalmente)",
    "mission_outcome_ph": "A mãe fica irritada, toda a gente está stressada...",
    "mission_activity": "A minha missão: atividade calma escolhida",
    "mission_activity_ph": "Desenho, BD, Lego, puzzle...",
    "mission_result": "Resultado da missão",
    "mission_result_ph": "Como correu? Consegui? Foi difícil?",
    "mission_done": "Missão cumprida!",
    "day_energy": "A minha energia ao longo do dia",
    "day_morning": "Manhã em casa",
    "day_commute": "Trajeto",
    "day_class_am": "Aula da manhã",
    "day_lunch": "Almoço",
    "day_afternoon": "Tarde",
    "day_sport": "Desporto / Atividade",
    "day_evening": "Noite",
    "day_bedtime": "Deitar",
    "day_full": "Cheio",
    "day_medium": "Médio",
    "day_empty": "Vazio",
    "day_need_move": "mexer",
    "day_need_talk": "falar",
    "day_need_calm": "estar calmo",
    "day_need_hug": "miminhos",
    "day_save": "Guardar o meu dia",
    "victory_title": "A minha vitória",
    "victory_examples": "Exemplos: Dormi sem acordar / Andei de metro sem stress / Comi toda a minha refeição / Consegui acalmar-me sozinho",
    "victory_ph": "Hoje, consegui...",
    "victory_proud": "Estou orgulhoso de mim porque...",
    "victory_proud_ph": "Porque foi difícil e consegui...",
    "victory_save": "Adicionar a minha estrela!",
    "questions_title": "As minhas perguntas",
    "questions_ph": "Pergunta",
    "questions_add": "Adicionar uma pergunta",
    "questions_save": "Enviar as minhas perguntas",
    "hist_intensity": "Intensidade",
    "hist_periods": "períodos registados"
  },
  "nl": {
    "superpowers_title": "Mijn Kosmische Superkrachten",
    "superpowers_subtitle": "Ontdek jouw geheime astronautenkrachten!",
    "safety_bubble_title": "Mijn Ruimtebubbel",
    "safety_bubble_subtitle": "Creëer jouw gepersonaliseerde beschermingsschild",
    "relaxation_title": "Terug in een baan",
    "relaxation_subtitle": "Spierontspanning om je motor te legen",
    "agitation_radar_title": "Mijn Galactische Radar",
    "agitation_radar_subtitle": "Detecteer en begrijp jouw sensaties",
    "recharge_title": "Oplaadstation",
    "recharge_subtitle": "Vind jouw activiteiten om je batterijen op te laden",
    "turbo_brain_title": "Mijn Turboschip",
    "turbo_brain_subtitle": "Begrijp jouw turbobrein en zijn rem",
    "mission_title": "Ruimtemissie",
    "mission_subtitle": "Ga uitdagingen aan op het gebied van zelfbeheersing!",
    "superhero_day_title": "Mijn Astronautendag",
    "superhero_day_subtitle": "Volg jouw energie gedurende de dag",
    "victories_title": "Mijn Overwinningssterren",
    "victories_subtitle": "Vier jouw successen, zelfs de kleinste!",
    "therapist_questions_title": "Bericht aan het Controlecentrum",
    "therapist_questions_subtitle": "Noteer jouw vragen voor jouw therapeut",
    "save": "Opslaan",
    "add": "Toevoegen",
    "other": "Iets anders...",
    "history": "Geschiedenis",
    "no_history": "Geen geschiedenis",
    "exercise_not_found": "Oefening niet gevonden",
    "saved_success": "Goed gedaan, oefening opgeslagen!",
    "save_error": "Fout bij het opslaan",
    "notes": "Notities",
    "notes_placeholder": "Waarnemingen van de dag...",
    "sp_known": "Mijn superkrachten die ik al ken",
    "sp_custom": "Wat zijn mijn andere superkrachten?",
    "sp_placeholder": "Superkracht",
    "sp_save": "Mijn superkrachten opslaan",
    "sp_preset_1": "Ik zie details die anderen niet zien",
    "sp_preset_2": "Ik heb veel ideeën om te spelen",
    "sp_preset_3": "Ik begrijp anderen als ze zich niet goed voelen",
    "sp_preset_4": "Ik ben super geconcentreerd als ik ergens gepassioneerd over ben",
    "bubble_color": "Welke kleur heeft mijn bubbel?",
    "bubble_color_hint": "Bijv.: kalm blauw, rustgevend groen, zacht roze...",
    "bubble_color_ph": "Kleur van mijn bubbel...",
    "bubble_shape": "Welke vorm heeft het?",
    "bubble_shape_hint": "Rond, vierkant, als een schild...",
    "bubble_shape_ph": "Vorm...",
    "bubble_texture": "Wat is de textuur ervan?",
    "bubble_texture_hint": "Zacht, stevig, glanzend...",
    "bubble_texture_ph": "Textuur...",
    "bubble_activities": "Wat mag ik doen in mijn bubbel?",
    "bubble_activities_hint": "Lezen, rustig spelen, tekenen, dromen...",
    "bubble_activities_ph": "Mijn activiteiten in de bubbel...",
    "bubble_noise": "Geluidsniveau in mijn bubbel",
    "bubble_noise_silence": "stilte",
    "bubble_noise_low": "een beetje",
    "bubble_noise_medium": "gemiddeld",
    "bubble_signal": "Hoe weten volwassenen wanneer ik om een bubbelpauze vraag?",
    "bubble_signal_hint": "Codewoord, kaart, gebaar...",
    "bubble_signal_ph": "Mijn signaal...",
    "bubble_save": "Mijn bubbel opslaan",
    "relax_steps_title": "Ontspanningsoefeningen",
    "relax_after": "Na de oefening voel ik me...",
    "relax_after_ph": "Rustiger, minder warm, ontspannen...",
    "relax_hands": "Handen",
    "relax_arms": "Armen",
    "relax_legs": "Benen",
    "relax_belly": "Buik",
    "relax_face": "Gezicht",
    "relax_s1": "Ik knijp mijn vuisten heel stevig samen, alsof ik een sinaasappel wil pletten. Ik tel tot 5.",
    "relax_s2": "Ik ontspan mijn handen zachtjes. Ik voel de ontspanning.",
    "relax_s3": "Ik strek mijn armen heel stevig, alsof ik het plafond wil aanraken. Ik tel tot 5.",
    "relax_s4": "Ik ontspan mijn armen zachtjes. Ik voel de ontspanning.",
    "relax_s5": "Ik span mijn benen heel stevig aan. Ik tel tot 5.",
    "relax_s6": "Ik ontspan mijn benen. Ik voel de ontspanning.",
    "relax_s7": "Ik span mijn buik heel stevig aan. Ik tel tot 5.",
    "relax_s8": "Ik ontspan mijn buik. Ik voel de ontspanning.",
    "relax_s9": "Ik trek een hele gekke bek (gespannen gezicht). Ik tel tot 5.",
    "relax_s10": "Ik ontspan mijn gezicht. Ik voel de ontspanning.",
    "radar_location": "Waar ik was / Wat ik deed",
    "radar_location_ph": "Thuis, in de klas...",
    "radar_sensations": "Wat ik voelde in mijn lichaam",
    "radar_sensations_ph": "Motor die trilt, benen die bewegen, zin om te praten, warm hoofd...",
    "radar_intensity": "Intensiteit (1 = een beetje, 10 = heel sterk)",
    "radar_boredom": "Niveau van verveling",
    "radar_urge": "Zin om te provoceren / kattenkwaad uit te halen",
    "radar_action": "Wat ik heb gedaan",
    "radar_action_ph": "Ik heb mijn bubbel gebruikt, ik heb mijn ontspanningsoefeningen gedaan...",
    "radar_after": "Hoe voelde ik me daarna?",
    "radar_after_ph": "Beter, hetzelfde, minder geagiteerd...",
    "recharge_what": "Wat heb ik gedaan?",
    "recharge_what_hint": "Lezen, Lego, tekenen, knuffelen, niets doen...",
    "recharge_what_ph": "Mijn kalmerende activiteit...",
    "recharge_during": "Hoe voelde ik me tijdens?",
    "recharge_during_ph": "Rustig, ontspannen, blij...",
    "recharge_after": "Hoe voelde ik me daarna?",
    "recharge_after_ph": "Opgeladen, klaar om te spelen, minder moe...",
    "turbo_helps": "Mijn turbo helpt me om...",
    "turbo_brake": "Als mijn rem moe is...",
    "turbo_preset_1": "Spelletjes bedenken",
    "turbo_preset_2": "Snel antwoorden",
    "turbo_preset_3": "Veel dingen opmerken",
    "turbo_brake_1": "Ik onderbreek anderen",
    "turbo_brake_2": "Ik doe domme dingen zonder na te denken",
    "turbo_brake_3": "Ik word plotseling boos",
    "mission_scenario": "De situatie",
    "mission_scenario_hint": "Bijv.: Mama maakt zich klaar, ik ben in de klas, we zijn in het restaurant...",
    "mission_scenario_ph": "Beschrijf de situatie...",
    "mission_usual": "Wat ik gewoonlijk doe",
    "mission_usual_ph": "Ik praat, ik raak alles aan, ik beweeg...",
    "mission_turbo": "Wat mijn turbo-brein me vertelt",
    "mission_turbo_ph": "Ik verveel me, ik wil nu praten, wat als ik veel vragen stel...",
    "mission_outcome": "Wat er daarna gebeurt (gewoonlijk)",
    "mission_outcome_ph": "Mama is geïrriteerd, iedereen is gestrest...",
    "mission_activity": "Mijn missie: gekozen rustige activiteit",
    "mission_activity_ph": "Tekenen, stripverhaal, Lego, puzzel...",
    "mission_result": "Resultaat van de missie",
    "mission_result_ph": "Hoe ging het? Is het gelukt? Was het moeilijk?",
    "mission_done": "Missie volbracht!",
    "day_energy": "Mijn energie gedurende de dag",
    "day_morning": "Ochtend thuis",
    "day_commute": "Reis",
    "day_class_am": "Ochtendles",
    "day_lunch": "Lunch",
    "day_afternoon": "Middag",
    "day_sport": "Sport / Activiteit",
    "day_evening": "Avond",
    "day_bedtime": "Bedtijd",
    "day_full": "Vol",
    "day_medium": "Gemiddeld",
    "day_empty": "Leeg",
    "day_need_move": "bewegen",
    "day_need_talk": "praten",
    "day_need_calm": "rustig zijn",
    "day_need_hug": "knuffels",
    "day_save": "Mijn dag opslaan",
    "victory_title": "Mijn overwinning",
    "victory_examples": "Voorbeelden: Ik sliep zonder wakker te worden / Ik nam de metro zonder stress / Ik at mijn hele maaltijd op / Het lukte me om mezelf te kalmeren",
    "victory_ph": "Vandaag is het me gelukt om...",
    "victory_proud": "Ik ben trots op mezelf omdat...",
    "victory_proud_ph": "Omdat het moeilijk was en het me gelukt is...",
    "victory_save": "Voeg mijn ster toe!",
    "questions_title": "Mijn vragen",
    "questions_ph": "Vraag",
    "questions_add": "Voeg een vraag toe",
    "questions_save": "Verstuur mijn vragen",
    "hist_intensity": "Intensiteit",
    "hist_periods": "bijgehouden periodes"
  }
};

export default extra;
